import { fromTime } from '../functions/Utilities'; 

const WaterDisruption = (props) => {  
 
return (  
        <div className="notice"> 
            <div className="notice_body" id="share">
                <div className="notice_type">GENERAL NOTICE</div>
                <div className="notice_subject">WATER DISRUPTION</div>
                <div className="notice_time"> 
                    {fromTime(props.notice.notice_time).toUpperCase()} 
                    {props.notice.notice_estimated != "" && props.notice.notice_estimated != null ? "-" + props.notice.notice_estimated.toUpperCase() : ""}
                </div>
                <div className="notice_title">  
                    {props.notice.notice_title}
                </div> 
                <div className="notice_affected">Areas/streets affected:</div>
                    <div className="notice_affected_streets"> 
                        
                        {props.notice.notice_estimated != "" && props.notice.notice_estimated != null ? 
                        <div className="row">
                        {props.notice.streets.map((street, key) => { 
                            return(
                                <div className="col-sm-6" key={key}>{street}</div> 
                            )})}
                        </div>
                        : <div className="center">  {props.notice.streets.toString().replaceAll(",",", ")} </div>} 
                    </div> 
                
                <div className="note_closing"> 
                    { props.notice.notice_estimated != "" && props.notice.notice_estimated != null ? 
                        "We urge customers to use water sparingly. Thank you for your patience."
                        :  "We urge customers to use water sparingly, as there is no estimated time for the restoration. Thank you for your patience." 
                    }   
                </div>

            </div> 
        </div>  
    );
}

export default WaterDisruption;

